import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { getCookie } from '../../../utils/getCookies'; 
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-company-main',
  standalone: true,
  imports: [MatButtonModule, CommonModule, TranslateModule],
  templateUrl: './company-main.component.html',
  styleUrl: './company-main.component.scss'
})
export class CompanyMainComponent {

  company_name = getCookie('company_name');

  constructor(public router: Router, private http: HttpClient) {

    this.getJobOffers();
   }

  jobOffers: any[] = [];
  create_offer() {

    this.router.navigate(['/dashboard/company/create-job-offer/step-1']);

  }
  getJobOffers(){
    const token = getCookie('access_token');
    this.http.get(`${environment.url}/api/v1/jobOffers`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).subscribe({
      next: (data: any) => {
        this.jobOffers = data["job_offers"];
        this.company_name = data["company_name"];
        document.cookie = `company_name=${this.company_name}; path=/;`;
      },
      error: (error) => {
        console.error('Error fetching job offers', error);
      }
    });

  }


}

